export const importance_ActionControl = "UGc";
export const getAddIns_Button_ActionControl = "VGc";
export const findTime_Button_ActionControl = "WGc";
export const attachFile_FlyoutButton_ActionControl = "XGc";
export const attachSig_FlyoutButton_ActionControl = "YGc";
export const sensitivity_FlyoutButton_ActionControl = "ZGc";
export const highImportance_Button_ActionControl = "_Gc";
export const clpLabelDropDownLearnMoreButtonText_ActionControl = "$Gc";
export const accCheckerText = "aHc";
export const emojiText = "bHc";
export const fluidText = "cHc";
export const tableText = "dHc";
export const inlineImageText = "eHc";
export const proofingOptionsText = "fHc";
export const saveDraftText = "gHc";
export const toggleFromText = "hHc";
export const toggleHideFromText = "iHc";
export const showMessageOptionsText = "jHc";
export const switchToPlainTextText = "kHc";
export const switchToHTMLTextText = "lHc";
export const toggleDarkComposeText = "mHc";
export const highImportance = "nHc";
export const lowImportance = "oHc";
export const normalImportance = "pHc";
export default {importance_ActionControl,getAddIns_Button_ActionControl,findTime_Button_ActionControl,attachFile_FlyoutButton_ActionControl,attachSig_FlyoutButton_ActionControl,sensitivity_FlyoutButton_ActionControl,highImportance_Button_ActionControl,clpLabelDropDownLearnMoreButtonText_ActionControl,accCheckerText,emojiText,fluidText,tableText,inlineImageText,proofingOptionsText,saveDraftText,toggleFromText,toggleHideFromText,showMessageOptionsText,switchToPlainTextText,switchToHTMLTextText,toggleDarkComposeText,highImportance,lowImportance,normalImportance};